function toast(item: IToast) {
  window.appState.toastStore.addToast(item);
}

const success = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'success',
    title: options.title || gettext('Success'),
    description: message,
  });
};

const error = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'error',
    title: options.title || gettext('Error'),
    description: message || gettext('Oops. Something went wrong.'),
  });
};

const errorBadRequest = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'error',
    title: options.title || gettext('Error'),
    description: message || gettext('Please correct the highlighted fields.'),
  });
};

const info = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'info',
    title: options.title || gettext('Info'),
    description: message,
  });
};

const warning = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'warning',
    title: options.title || gettext('Warning'),
    description: message,
  });
};

const itemSaved = (message?: React.ReactNode) => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Item was saved successfuly.'),
  });
};

const itemDeleted = (message?: React.ReactNode) => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Item was deleted successfuly.'),
  });
};

const settingsSaved = (message?: React.ReactNode) => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Settings were saved successfuly.'),
  });
};

export default {
  success,
  error,
  errorBadRequest,
  info,
  warning,
  itemSaved,
  itemDeleted,
  settingsSaved,
};
